import { axios, Response } from '../index'
import { GroupUsers } from './list-group-users'

type Body = {
  title: string
  personaType: string
}

const createAccessProfile = (body: Body): Response<GroupUsers> => {
  return axios.post('/v1/profiles', body)
}

export default createAccessProfile
